var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "b-navbar",
    { attrs: { type: "dark" } },
    [
      _c(
        "b-navbar-brand",
        { staticClass: "font-weight-bold", attrs: { href: "/" } },
        [_vm._v("PETRA")]
      ),
      _c(
        "b-navbar-nav",
        [
          _vm.isAdmin
            ? _c(
                "b-nav-item",
                [
                  _c("router-link", { attrs: { to: "/validationCycles" } }, [
                    _vm._v("Validation Cycles"),
                  ]),
                ],
                1
              )
            : _vm._e(),
          _vm.isAdmin
            ? _c(
                "b-nav-item",
                [
                  _c("router-link", { attrs: { to: "/rps" } }, [
                    _vm._v("Responsible Parties"),
                  ]),
                ],
                1
              )
            : _vm._e(),
          _c(
            "b-nav-item",
            [_c("router-link", { attrs: { to: "/ccds" } }, [_vm._v("CCDs")])],
            1
          ),
          _c(
            "b-nav-item",
            [
              _c("router-link", { attrs: { to: "/case/list" } }, [
                _vm._v("Review Cases"),
              ]),
            ],
            1
          ),
        ],
        1
      ),
      false
        ? _c(
            "b-navbar-nav",
            { staticClass: "ml-auto" },
            [
              _c(
                "b-nav-item-dropdown",
                {
                  attrs: { right: "" },
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "button-content",
                        fn: function () {
                          return [_c("em", [_vm._v("User")])]
                        },
                        proxy: true,
                      },
                    ],
                    null,
                    false,
                    4258386881
                  ),
                },
                [
                  _c("b-dropdown-item", { attrs: { href: "#" } }, [
                    _vm._v("Profile"),
                  ]),
                  _c("b-dropdown-item", { attrs: { href: "#" } }, [
                    _vm._v("Sign Out"),
                  ]),
                ],
                1
              ),
            ],
            1
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }